import { Link, useLocation } from 'react-router-dom';
import { ArrowLeftIcon, HomeIcon } from '@heroicons/react/24/outline';
import { useAuthStore } from '../store/authStore';
import MarketingLayout from '../components/marketing/MarketingLayout';

export default function NotFoundPage() {
  const location = useLocation();
  const { isAuthenticated } = useAuthStore();

  // Authenticated users get a bare in-app 404 (no marketing shell).
  if (isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4 py-16 bg-gray-50">
        <div className="max-w-xl text-center">
          <p className="text-sm font-semibold text-teal-600 uppercase tracking-wider">404 error</p>
          <h1 className="mt-4 text-4xl md:text-5xl font-bold text-navy-900">Page not found</h1>
          <p className="mt-4 text-lg text-gray-600">
            We couldn't find <code className="px-1.5 py-0.5 rounded bg-gray-100 text-gray-800">{location.pathname}</code>.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/dashboard" className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-teal-600 text-white font-medium hover:bg-teal-700 transition-colors">
              <HomeIcon className="w-5 h-5" /> Back to Dashboard
            </Link>
            <button type="button" onClick={() => window.history.back()} className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-lg border border-gray-300 bg-white text-gray-700 font-medium hover:bg-gray-50 transition-colors">
              <ArrowLeftIcon className="w-5 h-5" /> Go back
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Public 404 — banker-paper shell.
  return (
    <MarketingLayout footer={false}>
      <section className="section" style={{ textAlign: 'center' }}>
        <div className="container">
          <span className="kicker">§ 404 · NOT FOUND</span>
          <h1 className="display balance" style={{ marginTop: '1.25rem' }}>Page not found</h1>
          <p className="lead" style={{ margin: '1.25rem auto 0', maxWidth: '48ch' }}>
            We couldn&rsquo;t find <code>{location.pathname}</code>. The link may be broken, the
            page may have moved, or the URL may be mistyped.
          </p>
          <div style={{ marginTop: '2rem', display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" className="btn btn-primary">Back to home <span className="arrow">→</span></Link>
            <button type="button" onClick={() => window.history.back()} className="btn btn-secondary">Go back</button>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
